import { render, staticRenderFns } from "./create-weakspot.vue?vue&type=template&id=9a7678d8&scoped=true"
import script from "./create-weakspot.vue?vue&type=script&lang=js"
export * from "./create-weakspot.vue?vue&type=script&lang=js"
import style0 from "./create-weakspot.vue?vue&type=style&index=0&id=9a7678d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a7678d8",
  null
  
)

export default component.exports